/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslationParams, TranslationService } from '@gh/core-mls';
import { DialogInput } from '@gh/core-ui';

export interface DownloadDialogConfig {
  messageId?: string;
  messageParams?: TranslationParams;
  link?: string;
  fileName?: string;
}

@Component({
  selector: 'gh-download-dialog',
  template: require('./download-dialog.component.html'),
  styles: [require('./download-dialog.component.scss')],
})
export class DownloadDialogComponent implements OnInit, DialogInput<DownloadDialogConfig> {
  input: DownloadDialogConfig;
  message?: string;
  title?: string;
  description?: string;
  fileName?: string;
  link?: string;

  constructor(private translationService: TranslationService,
              public dialogRef: MatDialogRef<DownloadDialogConfig>,
              private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  ngOnInit(): void {
    const { messageId, messageParams, link, fileName } = this.input;

    if (messageId) {
      this.message = this.translationService.get(messageId, messageParams);

    }
    if (link) {
      this.fileName = fileName;
      this.link = link;
    }

    this.renderer.addClass(this.elementRef.nativeElement, 'message-dialog--simple');
  }
}
